import {Component, Input,} from '@angular/core';

/**
 * A component that renders an SVG icon for "Eye Off Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-eye-off-outline',
    templateUrl: './icon-eye-off-outline.component.html',
    styleUrls: ['./icon-eye-off-outline.component.scss'],
    standalone: false
})
export class IconEyeOffOutlineComponent  {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
